var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "article-allsee" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "allsee-list clear",
        attrs: { id: "allseeList", "data-spm": "fd-link" },
      },
      [
        _vm._l(_vm.items, function (item, index) {
          return [
            !item.adType
              ? _c(
                  "div",
                  {
                    key: index,
                    staticClass: "allsee-item clear",
                    attrs: {
                      "data-role": "allsee-item",
                      "data-newsid": item.position,
                      "data-media-id": item.authorId,
                      "data-loc": index,
                      "data-cate-id": item.cate_id,
                      "data-tag-id": item.tag_id,
                      "data-position": index,
                      "data-spm-type": "resource",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "allsee-image img-do",
                        attrs: {
                          href: item.url,
                          target: "_blank",
                          "data-spm-type": "content",
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            "data-src": item.image,
                            src: _vm.preloadUrl,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "allsee-title",
                        attrs: { href: item.url, target: "_blank" },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]
                )
              : _c("div", {
                  key: index,
                  staticClass: "allsee-item clear bd-wrap",
                  attrs: { id: item.randomId },
                }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [
        _c("em", { staticClass: "ln" }),
        _vm._v("\n\t\t\t\t大家都在看\n\t\t\t"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }